'use strict';

const DealCarousel = require('./DealCarousel.js');

const Carousel = {
  init(payload, done) {
    this.instance = new DealCarousel(payload);
    return done();
  },
};

module.exports = Carousel;
